module.exports = __webpack_public_path__ + "static/media/failed-capture-one.3d9313e0.png";